import { baseTheme_default } from './chunk-YD2QUJX6.mjs';
import { __spreadValues } from './chunk-D6FLC3TD.mjs';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

var theme = createTheme(__spreadValues({}, baseTheme_default));
var theme_default = responsiveFontSizes(theme);

export { theme_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-P4IX5WV7.mjs.map